/**
 * Pure helpers for Assign Counsellor reassignment flow.
 * Selection changes only affect the assignment operation, never counsellor relationships.
 */

export function hasExistingCounselor(student) {
	return Boolean(student?.counselorId)
}

export function getReassignmentStudents(selectedStudents) {
	const list = Array.isArray(selectedStudents) ? selectedStudents : []
	return list.filter(hasExistingCounselor)
}

export function removeIdsFromSelection(selectedIds, idsToRemove) {
	const remove = new Set((idsToRemove || []).map(id => String(id)))
	return (selectedIds || []).filter(id => !remove.has(String(id)))
}

export function getAssignModalViewAfterSelectionChange({
	view,
	selectedStudents,
}) {
	const reassignmentCount = getReassignmentStudents(selectedStudents).length
	if (view === 'reassign' && reassignmentCount === 0) {
		return 'assign'
	}
	return view === 'reassign' ? 'reassign' : 'assign'
}

export function shouldShowReassignmentWarning(selectedStudents) {
	return getReassignmentStudents(selectedStudents).length > 0
}
